import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ProviderPicker } from './ProviderPicker';

export const ProviderPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'ProviderPicker',
        // @ts-ignore
        component: ProviderPicker,
    }),
);
